"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.79 2.918c3.969 0 7.21 3.157 7.21 7.08 0 3.925-3.24 7.083-7.207 7.083-2.927 0-5.452-1.713-6.58-4.185a.7.7 0 1 1 1.273-.581c.904 1.98 2.937 3.367 5.307 3.367 3.22-.001 5.808-2.558 5.807-5.683 0-3.125-2.588-5.681-5.81-5.68a5.865 5.865 0 0 0-4.362 1.93H6.49a.7.7 0 1 1 0 1.4H3.7a.7.7 0 0 1-.7-.7V4.232a.7.7 0 0 1 1.4 0V5.3a7.266 7.266 0 0 1 5.39-2.38ZM10 6.006a.7.7 0 0 1 .7.7v3.6a.7.7 0 0 1-.424.644l-3.15 1.35a.7.7 0 1 1-.552-1.287L9.3 9.845V6.706a.7.7 0 0 1 .7-.7Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HistoryIcon20.js.map